export default __webpack_public_path__ + "static/media/perfume.f60a8c55.png";